<template>
  <div class="main_center" style="margin: 0 0; padding-top: 8px;">
    <div class="content" style="padding: 16px 16px 5px 16px;">
      <el-form ref="form" :model="form" label-width="100px">
        <el-row>
          <el-col :span="16">
            <el-form-item label="关键字：" props="searchKey">
              <el-input v-model="form.searchKey" clearable placeholder="请输入项目编号，项目名称，标段编号，标段名称关键字" @keyup.enter.native="searchBtn"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="">
              <div>
                <el-button plain size="small" type="primary" @click="reflash">重置</el-button>
                <el-button size="small" type="primary" @click="searchBtn">搜索</el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <space :left="-16" :right="-16" :bottom="16" />

      <el-table
        :data="tableData"
        v-loading="dataListLoading"
        ref="expertPayTable"
        :height="tableMaxHeight"
        stripe
        border
      >
        <el-table-column label="序号" type="index" :index="indexMethod" width="50" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="操作" align="center" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" title="查看详情" @click="handleClickRouter(scope.row)">查看</el-button>
          </template>
        </el-table-column>
        <el-table-column
          label="招标项目编号"
          prop="buyprojectCode"
          align="left"
          min-width="220"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="招标项目名称"
          prop="buyprojectName"
          align="left"
          min-width="300"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="相关标段编号"
          prop="sectionNums"
          align="left"
          min-width="220"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="相关标段名称"
          prop="sectionNames"
          align="left"
          min-width="300"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column label="评委到场时间" prop="arriveTime" align="left" width="180" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="评审结束时间" prop="evalEndTime" align="left" width="180" :show-overflow-tooltip="true"></el-table-column>
      </el-table>
      <pagination
        class="limit"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        :page.sync="pageIndex"
        :limit.sync="pageSize"
        @pagination="paginationChange"
      >
      </pagination>
    </div>
  </div>
</template>

<script>
import space from "../../common/components/space.vue";
import Pagination from "@/components/Pagination";

export default {
  name: "EvaluationExpertpay",
  components: {
    space,
    Pagination,
  },
  data() {
    return {
      form: {
        searchKey: "",
      },
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      dataListLoading: false,
      tableMaxHeight: document.documentElement.clientHeight - 275,
    };
  },
  methods: {
    ifmove() {
      const hasBtnPermisson = false;
      let tableMaxHeight = document.documentElement.clientHeight - 357 + (hasBtnPermisson ? 0 : 41);
      this.pageSize = parseInt(tableMaxHeight / 50) || 1;
      this.$nextTick(() => {
        this.tableMaxHeight = tableMaxHeight;
      });
    },
    searchBtn() {
      this.pageIndex = 1;
      this.getList();
    },
    reflash() {
      this.form = {
        searchKey: "",
      };
      this.pageIndex = 1;
      this.getList();
    },
    getList() {
      this.dataListLoading = true;
      const params = {
        page: this.pageIndex,
        rows: this.pageSize,
        searchKey: this.form.searchKey,
        filter: {},
      };
      this.$http.post(`/evaluationexpertpay/list`, params).then((res) => {
        this.tableData = res.data.rows;
        this.total = res.data.total;
        this.dataListLoading = false;
      }).catch((err) => {
        this.tableData = [];
        this.total = 0;
        this.dataListLoading = false;
        this.$message.error(err);
      });
    },
    paginationChange({ page, limit }) {
      this.pageIndex = page;
      this.pageSize = limit;
      this.getList();
    },
    indexMethod(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1;
    },
    handleClickRouter(item) {
      this.$router.push({
        name: "expertpayDetail",
        query: {
          id: item.id,
        },
      });
    },
  },
  activated() {
    this.getList();
  },
  mounted() {
    this.ifmove();
    let resizeTag = true;
    let that = this;
    window.onresize = () => {
      if (resizeTag) {
        //防抖动
        that.ifmove();
        resizeTag = false;
        setTimeout(() => {
          resizeTag = true;
        }, 1000);
      }
    };
  },
};
</script>
